import Cookies from "js-cookie";

export const getAuthenticatedUser = () => {
    return Cookies.get(".CreditTool.User");
}

export const useAuthenticatedUser = () => {
    return Cookies.get(".CreditTool.User");
}